import { AnalyticsEvent } from '@/types/analytics';
import { Get } from '../../helpers';
import filterParams from '../filter-params';

const GetChannelEvents = ({
  channel,
  start,
  end,
  audienceLists,
  offset,
  search,
  sort,
}: {
  channel: number;
  start?: number;
  end?: number;
  audienceLists?: string[];
  offset?: number;
  search?: string;
  sort?: string;
}): Promise<AnalyticsEvent[]> => {
  const optionalParams: Record<string, string | number> = {};

  if (search) {
    optionalParams.search = search;
  }

  if (sort) {
    optionalParams.sortBy = sort;
  }

  if (offset) {
    optionalParams.offset = offset;
    optionalParams.limit = 10;
  }

  return Get({
    path: `/v3/admin/metrics/channels/${channel}/events?${filterParams({ start, end, audienceLists, allowMultiAudienceLists: true }, optionalParams)}`,
    isMetrics: true,
  });
};

export default GetChannelEvents;
